import { I18nProvider } from '@refinedev/core';

import { restDataProvider } from './rest-data-provider';

const API_URL = '/client-proxy';

export const dataProvider = (i18nProvider: I18nProvider) => restDataProvider(API_URL, i18nProvider);
